export const dimensions = {
  empty: 0,
  none: 'none',
  auto: 'auto',
  unset: 'unset',
  inherit: 'inherit',
  percent0: '0%',
  percent10: '10%',
  percent20: '20%',
  percent24: '24%',
  percent25: '25%',
  percent27: '27%',
  percent28: '28%',
  percent30: '30%',
  percent32: '32%',
  percent33: '33%',
  percent40: '40%',
  percent48: '48%',
  percent50: '50%',
  percent60: '60%',
  percent61: '61%',
  percent62: '62%',
  percent65: '65%',
  percent68: '68%',
  percent70: '70%',
  percent75: '75%',
  percent80: '80%',
  percent85: '85%',
  percent92: '92%',
  percent90: '90%',
  percent95: '95%',
  percent99: '99%',
  percent100: '100%',
  width0: 0,
  width0rem: '0rem',
  width0p75: 0.75,
  width1: 1,
  width1rem: '0.0625rem',
  width2: 2,
  width2rem: '0.125rem',
  width2p5: 2.5,
  width2p5rem: '0.15625rem',
  width3: 3,
  width3rem: '0.1875rem',
  width4: 4,
  width4rem: '0.25rem',
  width5: 5,
  width5rem: '0.3125rem',
  width6: 6,
  width6rem: '0.375rem',
  width7: 7,
  width7rem: '0.4375rem',
  width8: 8,
  width8rem: '0.5rem',
  width9: 9,
  width9rem: '0.5625rem',
  width10: 10,
  width10rem: '0.625rem',
  width11: 11,
  width11rem: '0.6875rem',
  width12: 12,
  width12rem: '0.75rem',
  width13: 13,
  width13rem: '0.8125rem',
  width14: 14,
  width14rem: '0.875rem',
  width15: 15,
  width15rem: '0.9375rem',
  width16: 16,
  width16rem: '1rem',
  width17: 17,
  width17rem: '1.0625rem',
  width18: 18,
  width18rem: '1.125rem',
  width19: 19,
  width19rem: '1.1875rem',
  width20: 20,
  width20rem: '1.25rem',
  width21: 21,
  width21rem: '1.3125rem',
  width22: 22,
  width22rem: '1.375rem',
  width23: 23,
  width23rem: '1.4375rem',
  width24: 24,
  width24rem: '1.5rem',
  width25: 25,
  width25rem: '1.5625rem',
  width26: 26,
  width26rem: '1.625rem',
  width27: 27,
  width27rem: '1.6875rem',
  width28: 28,
  width28rem: '1.75rem',
  width29: 29,
  width29rem: '1.8125rem',
  width30: 30,
  width30rem: '1.875rem',
  width31: 31,
  width31rem: '1.9375rem',
  width32: 32,
  width32rem: '2rem',
  width33: 33,
  width33rem: '2.0625rem',
  width34: 34,
  width34rem: '2.125rem',
  width35: 35,
  width35rem: '2.1875rem',
  width36: 36,
  width36rem: '2.25rem',
  width37: 37,
  width37rem: '2.3125rem',
  width38: 38,
  width40: 40,
  width40rem: '2.5rem',
  width41: 41,
  width41rem: '2.5625rem',
  width42: 42,
  width42rem: '2.625rem',
  width43: 43,
  width43rem: '2.6875rem',
  width44: 44,
  width44rem: '2.75rem',
  width45: 45,
  width45rem: '2.8125rem',
  width46: 46,
  width47: 47,
  width48: 48,
  width48rem: '3rem',
  width49: 49,
  width49rem: '3.0625rem',
  width50: 50,
  width50rem: '3.125rem',
  width51: 51,
  width51rem: '3.1875rem',
  width54: 54,
  width54rem: '3.375rem',
  width55: 55,
  width55rem: '3.4375rem',
  width56: 56,
  width56rem: '3.5rem',
  width57: 57,
  width57rem: '3.5625rem',
  width58: 58,
  width58rem: '3.625rem',
  width60: 60,
  width61: 61,
  width60rem: '3.75rem',
  width63: 63,
  width64: 64,
  width64rem: '4rem',
  width65: 65,
  width65rem: '4.0625rem',
  width66: 66,
  width66rem: '4.125rem',
  width68: 68,
  width69: 69,
  width68rem: '4.25rem',
  width70: 70,
  width70rem: '4.375rem',
  width72: 72,
  width74: 74,
  width74rem: '4.625rem',
  width75: 75,
  width75rem: '4.6875rem',
  width71: 71,
  width71rem: '4.4375rem',
  width78: 78,
  width80: 80,
  width80rem: '5rem',
  width85: 85,
  width85rem: '5.3125rem',
  width86: 86,
  width86rem: '5.375rem',
  width87: 87,
  width87rem: '5.4375rem',
  width90: 90,
  width90rem: '5.625rem',
  width94: 94,
  width94rem: '5.875rem',
  width95: 95,
  width95rem: '5.9375rem',
  width99: 99,
  width99rem: '6.1875rem',
  width100: 100,
  width100rem: '6.25rem',
  width102: 102,
  width102rem: '6.375rem',
  width108: 108,
  width108rem: '6.75rem',
  width109: 109,
  width111: 111,
  width111rem: '6.9375rem',
  width112: 112,
  width112rem: '7rem',
  width115: 115,
  width115rem: '7.1875rem',
  width117: 117,
  width117rem: '7.3125rem',
  width118: 118,
  width118rem: '7.375rem',
  width120: 120,
  width120rem: '7.5rem',
  width121: 121,
  width121rem: '7.5625rem',
  width123: 123,
  width123rem: '7.6875rem',
  width124: 124,
  width124rem: '7.75rem',
  width129: 129,
  width129rem: '8.0625rem',
  width130: 130,
  width130rem: '8.125rem',
  width135: 135,
  width135rem: '8.4375rem',
  width136: 136,
  width136rem: '8.5rem',
  width137: 137,
  width137rem: '8.5625rem',
  width140: 140,
  width140rem: '8.75rem',
  width142: 142,
  width142rem: '8.875rem',
  width143: 143,
  width143rem: '8.9375rem',
  width144: 144,
  width144rem: '9rem',
  width145: 145,
  width145rem: '9.0625rem',
  width148: 148,
  width148rem: '9.25rem',
  width150: 150,
  width150rem: '9.375rem',
  width152: 152,
  width152rem: '9.5rem',
  width160: 160,
  width160rem: '10rem',
  width164: 164,
  width164rem: '10.25rem',
  width165: 165,
  width165rem: '10.3125rem',
  width166: 166,
  width166rem: '10.375rem',
  width170: 170,
  width170rem: '10.625rem',
  width175: 175,
  width175rem: '10.9375rem',
  width180: 180,
  width180rem: '11.25rem',
  width184: 184,
  width184rem: '11.5rem',
  width185: 185,
  width185rem: '11.5625rem',
  width190: 190,
  width190rem: '11.875rem',
  width191: 191,
  width191rem: '11.9375rem',
  width192: 192,
  width192rem: '12rem',
  width200: 200,
  width200rem: '12.5rem',
  width205: 205,
  width205rem: '12.8125rem',
  width206: 206,
  width210: 210,
  width210rem: '13.125rem',
  width206rem: '12.875rem',
  width211: 211,
  width211rem: '13.1875rem',
  width215: 215,
  width215rem: '13.4375rem',
  width220: 220,
  width220rem: '13.75rem',
  width225: 225,
  width225rem: '14.0625rem',
  width228: 228,
  width228rem: '14.25rem',
  width230: 230,
  width230rem: '14.375rem',
  width232: 232,
  width232rem: '14.5rem',
  width234: 234,
  width235: 235,
  width235rem: '14.6875rem',
  width236: 236,
  width236rem: '14.75rem',
  width240: 240,
  width240rem: '15rem',
  width244: 244,
  width244rem: '15.25rem',
  width245: 245,
  width245rem: '15.3125rem',
  width248: 248,
  width248rem: '15.5rem',
  width250: 250,
  width250rem: '15.625rem',
  width255: 255,
  width255rem: '15.9375rem',
  width260: 260,
  width260rem: '16.25rem',
  width270: 270,
  width270rem: '16.875rem',
  width275: 275,
  width275rem: '17.1875rem',
  width280: 280,
  width280rem: '17.5rem',
  width282: 282,
  width282rem: '17.625rem',
  width284: 284,
  width284rem: '17.75rem',
  width292: 292,
  width298: 298,
  width298rem: '18.625rem',
  width300: 300,
  width300rem: '18.75rem',
  width303: 303,
  width303rem: '18.9375rem',
  width305: 305,
  width305rem: '19.0625rem',
  width310: 310,
  width310rem: '19.375rem',
  width312: 312,
  width312rem: '19.5rem',
  width313: 313,
  width313rem: '19.5625rem',
  width319: 319,
  width319rem: '19.9375rem',
  width320: 320,
  width320rem: '20rem',
  width323: 323,
  width323rem: '20.1875rem',
  width330: 330,
  width330rem: '20.625rem',
  width335: 335,
  width335rem: '20.9375rem',
  width337: 337,
  width339: 339,
  width339rem: '21.1875rem',
  width344: 344,
  width344rem: '21.5rem',
  width347: 347,
  width350: 350,
  width350rem: '21.875rem',
  width352: 352,
  width352rem: '22rem',
  width354: 354,
  width360: 360,
  width360rem: '22.5rem',
  width364: 364,
  width364rem: '22.75rem',
  width368: 368,
  width368rem: '23rem',
  width370: 370,
  width370rem: '23.125rem',
  width376: 376,
  width377: 377,
  width377rem: '23.5625rem',
  width380: 380,
  width380rem: '23.75rem',
  width400: 400,
  width400rem: '25rem',
  width405: 405,
  width405rem: '25.3125rem',
  width425: 425,
  width425rem: '26.5625rem',
  width427: 427,
  width429: 429,
  width429rem: '26.8125rem',
  width430: 430,
  width430rem: '26.875rem',
  width435: 435,
  width438: 438,
  width435rem: '27.1875rem',
  width440: 440,
  width440rem: '27.5rem',
  width443: 443,
  width448: 448,
  width443rem: '27.6875rem',
  width450: 450,
  width450rem: '28.125rem',
  width457: 457,
  width457rem: '28.5625rem',
  width480: 480,
  width480rem: '30rem',
  width490: 490,
  width494: 494,
  width498: 498,
  width494rem: '30.875rem',
  width500: 500,
  width500rem: '31.25rem',
  width504: 504,
  width512: 512,
  width512rem: '32rem',
  width521: 521,
  width521rem: '32.5625rem',
  width528: 528,
  width528rem: '33rem',
  width530: 530,
  width530rem: '33.125rem',
  width552: 552,
  width552rem: '34.5rem',
  width544: 544,
  width544rem: '34rem',
  width558: 558,
  width558rem: '34.875rem',
  width560: 560,
  width565: 565,
  width565rem: '35.3125rem',
  width600: 600,
  width600rem: '37.5rem',
  width601: 601,
  width601rem: '37.5625rem',
  width615: 615,
  width620: 620,
  width620rem: '38.75rem',
  width629: 629,
  width629rem: '39.3125rem',
  width630: 630,
  width630rem: '39.375rem',
  width647: 647,
  width647rem: '40.4375rem',
  width649: 649,
  width649rem: '40.5625rem',
  width650: 650,
  width652: 652,
  width652rem: '40.75rem',
  width667: 667,
  width667rem: '41.6875rem',
  width673: 673,
  width673rem: '42.0625rem',
  width700: 700,
  width700rem: '43.75rem',
  width736: 736,
  width736rem: '46rem',
  width750: 750,
  width750rem: '46.875rem',
  width752: 752,
  width752rem: '47rem',
  width800: 800,
  width800rem: '50rem',
  width885: 885,
  width885rem: '55.3125rem',
  width900: 900,
  width900rem: '56.25rem',
  width960: 960,
  width960rem: '60rem',
  widthOccupationModal: 'min(956px, calc(100vw - 64px))',
  heightOccupationModal: 'min(848px, 82dvh)',
  width1000: 1000,
  width1000rem: '62.5rem',
  width1151: 1151,
  width1151rem: '71.9375rem',
  width1200: 1200,
  width1200rem: '75rem',
  width1536: 1536,
  width1536rem: '96rem',
  width50vw: '50vw',
  width55vw: '55vw',
  width60vw: '60vw',
  width66vw: '66vw',
  width75vw: '75vw',
  width80vw: '80vw',
  width85vw: '85vw',
  width90vw: '90vw',
  width100vw: '100vw',
  width6vw: '6vw',
  width8vw: '8vw',
  width12vw: '12vw',
  width16vw: '16vw',
  width20vw: '20vw',
  height1: 1,
  Height1rem: '0.0625rem',
  height0p75: 0.75,
  height1p5: 1.5,
  height2: 2,
  height2rem: '0.125rem',
  height3: 3,
  height3rem: '0.1875rem',
  height4: 4,
  height4rem: '0.25rem',
  height5: 5,
  height5rem: '0.3125rem',
  height6: 6,
  height6rem: '0.375rem',
  height8: 8,
  height8rem: '0.5rem',
  height9: 9,
  height9rem: '0.5625rem',
  height10: 10,
  height10rem: '0.625rem',
  height11: 11,
  height11rem: '0.6875rem',
  height12: 12,
  height12rem: '0.75rem',
  height13: 13,
  height13rem: '0.8125rem',
  height14: 14,
  height14rem: '0.875rem',
  height15: 15,
  height15rem: '0.9375rem',
  height16: 16,
  height16rem: '1rem',
  height17: 17,
  height17rem: '1.0625rem',
  height18: 18,
  height18rem: '1.125rem',
  height19: 19,
  height19rem: '1.1875rem',
  height20: 20,
  height20rem: '1.25rem',
  height21: 21,
  height21rem: '1.3125rem',
  height22: 22,
  height22rem: '1.375rem',
  height23: 23,
  height23rem: '1.4375rem',
  height24: 24,
  height24rem: '1.5rem',
  height25: 25,
  height25rem: '1.5625rem',
  height26: 26,
  height26rem: '1.625rem',
  height27: 27,
  height27rem: '1.6875rem',
  height28: 28,
  height28rem: '1.75rem',
  height29: 29,
  height29rem: '1.8125rem',
  height30: 30,
  height30rem: '1.875rem',
  height31: 31,
  height31rem: '1.9375rem',
  height32: 32,
  height32rem: '2rem',
  height33: 33,
  height33rem: '2.0625rem',
  height34: 34,
  height34rem: '2.125rem',
  height35: 35,
  height35rem: '2.1875rem',
  height36: 36,
  height36rem: '2.25rem',
  height37: 37,
  height37rem: '2.3125rem',
  height38: 38,
  height39: 39,
  height38rem: '2.375rem',
  height40: 40,
  height40rem: '2.5rem',
  height41: 41,
  height41rem: '2.5625rem',
  height42: 42,
  height42rem: '2.625rem',
  height43: 43,
  height43rem: '2.6875rem',
  height44: 44,
  height44rem: '2.75rem',
  height45: 45,
  height45rem: '2.8125rem',
  height46: 46,
  height46rem: '2.875rem',
  height47: 47,
  height48: 48,
  height48rem: '3rem',
  height50: 50,
  height50rem: '3.125rem',
  height51: 51,
  height51rem: '3.1875rem',
  height54: 54,
  height54rem: '3.375rem',
  height55: 55,
  height55rem: '3.4375rem',
  height56: 56,
  height56rem: '3.5rem',
  height57: 57,
  height57rem: '3.5625rem',
  height58: 58,
  height58rem: '3.625rem',
  height59: 59,
  height60: 60,
  height60rem: '3.75rem',
  height63: 63,
  height64: 64,
  height64rem: '4rem',
  height65: 65,
  height65rem: '4.0625rem',
  height66: 66,
  height66rem: '4.125rem',
  height67: 67,
  height67rem: '4.1875rem',
  height68: 68,
  height68rem: '4.25rem',
  height69: 69,
  height69rem: '4.3125rem',
  height70: 70,
  height70rem: '4.375rem',
  height72: 72,
  height74: 74,
  height74rem: '4.625rem',
  height75: 75,
  height75rem: '4.6875rem',
  height78: 78,
  height78rem: '4.875rem',
  height79: 79,
  height79rem: '4.9375rem',
  height80: 80,
  height80rem: '5rem',
  height82: 82,
  height82rem: '5.125rem',
  height83: 83,
  height83rem: '5.1875rem',
  height84: 84,
  height84rem: '5.25rem',
  height85: 85,
  height85rem: '5.3125rem',
  height87: 87,
  height87rem: '5.4375rem',
  height88: 88,
  height88rem: '5.5rem',
  height90: 90,
  height90rem: '5.625rem',
  height92: 92,
  height92rem: '5.75rem',
  height93: 93,
  height93rem: '5.8125rem',
  height95: 95,
  height95rem: '5.9375rem',
  height96: 96,
  height96rem: '6rem',
  height97: 97,
  height97rem: '6.0625rem',
  height98: 98,
  height98rem: '6.125rem',
  height100: 100,
  height100rem: '6.25rem',
  height102: 102,
  height102rem: '6.375rem',
  height104: 104,
  height104rem: '6.5rem',
  height105: 105,
  height105rem: '6.5625rem',
  height106: 106,
  height106rem: '6.625rem',
  height110: 110,
  height110rem: '6.875rem',
  height112: 112,
  height112rem: '7rem',
  height114: 114,
  height114rem: '7.125rem',
  height115: 115,
  height115rem: '7.1875rem',
  height117: 117,
  height117rem: '7.3125rem',
  height116: 116,
  height118: 118,
  height118rem: '7.375rem',
  height119: 119,
  height119rem: '7.4375rem',
  height120: 120,
  height120rem: '7.5rem',
  height125: 125,
  height125rem: '7.8125rem',
  height126: 126,
  height126rem: '7.875rem',
  height127: 127,
  height127rem: '7.9375rem',
  height129: 129,
  height129rem: '8.0625rem',
  height130: 130,
  height130rem: '8.125rem',
  height131: 131,
  height131rem: '8.1875rem',
  height135: 135,
  height135rem: '8.4375rem',
  height136: 136,
  height136rem: '8.5rem',
  height138: 138,
  height138rem: '8.625rem',
  height140: 140,
  height140rem: '8.75rem',
  height141: 141,
  height141rem: '8.8125rem',
  height142: 142,
  height142rem: '8.875rem',
  height144: 144,
  height144rem: '9rem',
  height145: 145,
  height145rem: '9.0625rem',
  height150: 150,
  height150rem: '9.375rem',
  height151: 151,
  height151rem: '9.4375rem',
  height153: 153,
  height153rem: '9.5625rem',
  height154: 154,
  height154rem: '9.625rem',
  height155: 155,
  height155rem: '9.6875rem',
  height156: 156,
  height156rem: '9.75rem',
  height160: 160,
  height160rem: '10rem',
  height165: 165,
  height165rem: '10.3125rem',
  height166: 166,
  height166rem: '10.375rem',
  height168: 168,
  height168rem: '10.5rem',
  height170: 170,
  height170rem: '10.625rem',
  height175: 175,
  height175rem: '10.9375rem',
  height179: 179,
  height179rem: '11.1875rem',
  height180: 180,
  height180rem: '11.25rem',
  height182: 182,
  height182rem: '11.375rem',
  height185: 185,
  height185rem: '11.5625rem',
  height187: 187,
  height187rem: '11.6875rem',
  height188: 188,
  height188rem: '11.75rem',
  height192: 192,
  height192rem: '12rem',
  height194: 194,
  height194rem: '12.125rem',
  height200: 200,
  height200rem: '12.5rem',
  height201: 201,
  height201rem: '12.5625rem',
  height202: 202,
  height202rem: '12.625rem',
  height204: 204,
  height204rem: '12.75rem',
  height205: 205,
  height205rem: '12.8125rem',
  height210: 210,
  height215: 215,
  height215rem: '13.4375rem',
  height212: 212,
  height212rem: '13.25rem',
  height216: 216,
  height216rem: '13.5rem',
  height219: 219,
  height219rem: '13.6875rem',
  height220: 220,
  height220rem: '13.75rem',
  height222: 222,
  height222rem: '13.875rem',
  height224: 224,
  height224rem: '14rem',
  height227: 227,
  height227rem: '14.1875rem',
  height228: 228,
  height228rem: '14.25rem',
  height230: 230,
  height230rem: '14.375rem',
  height232: 232,
  height232rem: '14.5rem',
  height234: 234,
  height234rem: '14.625rem',
  height238: 238,
  height238rem: '14.875rem',
  height240: 240,
  height240rem: '15rem',
  height245: 245,
  height245rem: '15.3125rem',
  height247: 247,
  height247rem: '15.4375rem',
  height242: 242,
  height242rem: '15.125rem',
  height244: 244,
  height244rem: '15.25rem',
  height248: 248,
  height248rem: '15.5rem',
  height250: 250,
  height250rem: '15.625rem',
  height252: 252,
  height252rem: '15.75rem',
  height254: 254,
  height254rem: '15.875rem',
  height257: 257,
  height257rem: '16.0625rem',
  height260: 260,
  height260rem: '16.25rem',
  height264: 264,
  height264rem: '16.5rem',
  height265: 265,
  height265rem: '16.5625rem',
  height267: 267,
  height280: 280,
  height280rem: '17.5rem',
  height282: 282,
  height282rem: '17.625rem',
  height290: 290,
  height290rem: '18.125rem',
  height291: 291,
  height291rem: '18.1875rem',
  height294: 294,
  height294rem: '18.375rem',
  height298: 298,
  height298rem: '18.625rem',
  height300: 300,
  height300rem: '18.75rem',
  height310: 310,
  height320: 320,
  height320rem: '20rem',
  height324: 324,
  height324rem: '20.25rem',
  height335: 335,
  height335rem: '20.9375rem',
  height340: 340,
  height350: 340,
  height350rem: '21.875rem',
  height360: 360,
  height364: 364,
  height364rem: '22.75rem',
  height326: 326,
  height330: 330,
  height326rem: '20.375rem',
  height370: 370,
  height370rem: '23.125rem',
  height384: 384,
  height390: 390,
  height392: 392,
  height392rem: '24.5rem',
  height395: 395,
  height395rem: '24.6875rem',
  height400: 400,
  height400rem: '25rem',
  height406: 406,
  height418: 418,
  height418rem: '26.125rem',
  height420: 420,
  height434: 434,
  height434rem: '27.125rem',
  height438: 438,
  height438rem: '27.375rem',
  height450: 450,
  height450rem: '28.125rem',
  height457: 457,
  height457rem: '28.5625rem',
  height459: 459,
  height459rem: '28.6875rem',
  height460: 460,
  height460rem: '28.75rem',
  height461: 461,
  height465: 465,
  height461rem: '28.8125rem',
  height489: 489,
  height489rem: '30.5625rem',
  height500: 500,
  height500rem: '31.25rem',
  height508: 508,
  height510: 510,
  height508rem: '31.75rem',
  height560: 560,
  height560rem: '35rem',
  height573: 573,
  height546: 546,
  height600: 600,
  height640: 640,
  height640rem: '40rem',
  height650: 650,
  height650rem: '40.625rem',
  height700: 700,
  height700rem: '43.75rem',
  height748: 748,
  height748rem: '46.75rem',
  height750: 750,
  height750rem: '46.875rem',
  height850: 850,
  height850rem: '53.125rem',
  height878: 878,
  height1000: 1000,
  height1000rem: '62.5',
  height1500: 1500,
  height1500rem: '93.75rem',
  height1600: 1600,
  height1600rem: '100rem',
  height1700: 1700,
  height1700rem: '106.25rem',
  height1800: 1800,
  height1800rem: '112.5rem',
  height28vh: '28vh',
  height37vh: '37vh',
  height40vh: '40vh',
  height50vh: '50vh',
  height60vh: '60vh',
  height63vh: '63vh',
  height65vh: '65vh',
  height70vh: '70vh',
  height75vh: '75vh',
  height80vh: '80vh',
  height85vh: '85vh',
  height90vh: '90vh',
  height100vh: '100vh',
  height30svh: '30svh',
  height40svh: '40svh',
  height75svh: '75svh',
  height100svh: '100svh',
  height10dvh: '10dvh',
  height30dvh: '30dvh',
  height40dvh: '40dvh',
  height60dvh: '60dvh',
  height70dvh: '70dvh',
  height80dvh: '80dvh',
  height90dvh: '90dvh',
  height100dvh: '100dvh',
  iconSize70p31: 70.31,
  iconSize145: 145,
  listAvatarSize: 24,
  minWidthCard: 250,
  fieldHightLarger: 56,
  selectItemList: 150,
  editIcon: 18,
  visibilityIcon: 25,
  coursesEmptyStateHeight: 300,
  firstListCircle: 44,
  modalActionButtonContainerBoxShadowLeft: '0px 0px 2px',
  modalActionButtonContainerBoxShadowRight: '0px 20px 40px -4px',
  skillModal: 480,
  buttonBorderWidth: 1.5,
  topListRowGap: 10,
  fractionColumn4: '1fr 1fr 1fr 1fr',
  fractionColumn3: '1fr 1fr 1fr',
  fractionColumn2: '1fr 1fr',
  fractionColumn1: '1fr',
  fractionLogin: '50px 1fr 50px',
  gridColumn: '1 / -1',
  dotSevenRem: '0.7rem',
  oneRem: '1rem',
  twoRem: '2rem',
  fourRem: '4rem',
  modalHeaderLogoMobile: 37,
  modalHeaderLogo: 57,
  providerLogoW: 75,
  providerLogoH: 15,
  gap1: 1,
  gap2: 2,
  gap10: 10,
  gap12: 12,
  gap24: 24,
  breakpoint1370: 1370,
  breakpoint1260: 1260,
  breakpoint1100: 1100,
  width77vw: '77vw',
  width42vw: '42vw',
  width35vw: '35vw',
  width17p5vw: '17.5vw',
  gap9vw: '9vw',
  gap5vw: '5vw',
  width4vw: '4vw',
  width36p5vw: '36.5vw',
  border2px: '2px',
  marginTopMinus4vw: '-4vw',
  marginLeftMinus8vw: '-8vw',
  height51vh: '51vh',
  height23vh: '23vh',
  height11p5vh: '11.5vh',
  gap6vh: '6vh',
  gap4vh: '4vh',
  height3vh: '3vh',
  height24vh: '24vh',
  border3px: '3px',
  marginTopMinus3vh: '-3vh',
  marginLeftMinus6vh: '-6vh',
  heightClamp180: 'clamp(180px, 24vh, 260px)',
  heightClamp440: 'clamp(440px, 48vh, 560px)',
  transitionDuration350: 350,
  transitionDuration250: 250,
  topNegative9: -9,
  zIndex1: 1,
  zIndex2: 2,
};
